module.exports = __webpack_public_path__ + "static/media/Geomanist-Bold.748e4c83.otf";